import { POST } from '@wellsfargo/ecpfs-authority'

export const PRIVACY_POLICY_PATH = 'login/footer/pp/text.json'

export function fetchPrivacyPolicy() {
	return POST(PRIVACY_POLICY_PATH, {})
}
